import * as THREE from 'three'

/**
 * Teknoloji dekorları — tools/blender/decor.py. Giriş: telefon, mouse, gözlük, { } ve </>, tuş kapakları,
 * low-poly ağaçlar; oyun alanı: konsol + gamepad, folio ağaçlarının yerine low-poly ağaçlar (yuvarlak / çiçekli / çam).
 * Konumlar dünya koordinatıdır; boşluklar sayfa içi çakışma haritasıyla doğrulandı (doğma noktası çevresi ≥ 3 m).
 */
const PLACEMENTS = [
    // [model, x, y, dönüş (rad), renk (yalnız hareketlilerde), kütle, ses]
    // Giriş (eski folio ağaç/kaya yerleri)
    ['phone', - 9.2, 5.6, 0.26, null, 0, null],
    ['treeRound', - 5.4, 3.9, 0, null, 0, null],
    ['treeBlossom', 8.4, - 10.2, 0.6, null, 0, null],
    ['mouse', 8.6, - 0.6, 0.45, null, 3, 'plastic'],
    ['glasses', 3.8, 7.6, - 0.3, null, 1.5, 'glass'], // Vision Pro tarzı başlık: yeni kutusu (3.4, 6.9)'da tuş kapağına giriyordu
    ['braceOpen', - 5.6, - 1.6, 0, null, 1, 'block'],
    ['braceClose', - 4.0, - 1.6, 0, null, 1, 'block'],
    // </> üç ayrı parça, sırtüstü yatık; aynı doğrultuda (0.2 rad) dizili
    ['codeLt', - 9.31, - 12.79, 0.2, null, 1, 'block'],
    ['codeSlash', - 7.4, - 12.4, 0.2, null, 1.2, 'block'],
    ['codeGt', - 5.49, - 12.01, 0.2, null, 1, 'block'],
    ['keycap', 1.0, 3.9, 0.3, 'accent', 0.5, 'plastic'],
    ['keycap', 2.2, 4.8, - 0.2, 'teal', 0.5, 'plastic'],
    ['keycap', - 2.2, 3.4, 0.1, 'raspberry', 0.5, 'plastic'],
    ['keycap', - 7.6, - 5.6, 0.4, 'violet', 0.5, 'plastic'],

    // Oyun alanı girişi: konsol + gamepad
    ['console', - 24.5, - 36.5, 0.15, null, 0, null],
    ['gamepad', - 20.9, - 33.4, - 0.35, null, 3, 'plastic'],

    // Oyun alanı: silinen folio ağaçlarının yerleri (PlaygroundSection x -38, y -34 + yerel konum)
    ['treePine', - 47.46, - 24.09, 0, null, 0, null],
    ['treeRound', - 26.4, - 23.6, 1.2, null, 0, null], // eski yer kayayla, (-27.5,-23) tuğla duvarla çakışıyordu
    ['treeBlossom', - 52.86, - 26.07, 2.1, null, 0, null],
    ['treePine', - 39.8, - 37.4, 0.8, null, 0, null], // eski yer (-41.2, -35.44) kayayla çakışıyordu
    ['treeRound', - 22.84, - 46.13, 2.6, null, 0, null],
    ['treePine', - 48.82, - 38.51, 1.7, null, 0, null]
]

// Hareketli dekorların yumuşak gölge boyu (x, y) — büyütülen modellere göre
const SHADOWS = {
    mouse: [1.9, 3],
    glasses: [3.8, 3.4],
    gamepad: [4.4, 2.6],
    codeLt: [1.9, 2],
    codeSlash: [2, 3.1],
    codeGt: [1.9, 2]
}

export default class DecorSection
{
    constructor(_options)
    {
        this.resources = _options.resources
        this.objects = _options.objects
        this.materials = _options.materials

        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.items = PLACEMENTS.map(([_model, _x, _y, _rotation, _color, _mass, _sound]) =>
        {
            const name = `${_model.substring(0, 1).toUpperCase()}${_model.substring(1)}`
            const options = {
                base: this.resources.items[`decor${name}Base`].scene,
                collision: this.resources.items[`decor${name}Collision`].scene,
                offset: new THREE.Vector3(_x, _y, 0),
                rotation: new THREE.Euler(0, 0, _rotation),
                duplicated: true,
                mass: _mass
            }

            if(_mass === 0)
            {
                options.floorShadowTexture = this.resources.items[`decor${name}FloorShadowTexture`]
            }
            else
            {
                const [sizeX, sizeY] = SHADOWS[_model] || [1.6, 1.4]
                options.shadow = { sizeX, sizeY, offsetZ: - 0.2, alpha: 0.35 }
                options.soundName = _sound
            }

            if(_color)
            {
                options.material = this.materials.items[_color]
            }

            const item = this.objects.add(options)
            item.model = _model
            return item
        })
    }
}
